<template>
  <div class="w-full h-auto float-left rounded-lg bg-white px-5 py-4 shadow" style="transition: 1s">
    <div class="spring-spinner" :class="{ hidden: !loading }">
      <div class="spring-spinner-part top">
        <div class="spring-spinner-rotator"></div>
      </div>
      <div class="spring-spinner-part bottom">
        <div class="spring-spinner-rotator"></div>
      </div>
    </div>
    <div class="w-full float-left flex flex-col gap-5 font-medium" :class="{ hidden: loading }" style="transition: 1s">
      <div class="w-full float-left">
        <div class="w-full float-left">
          <p class="float-left text-black text-sm">Order #{{ data.id }}</p>
          <p class="float-right text-gray text-sm">
            {{ $t(`order-statuses.${data.status}`) }}
          </p>
        </div>



      </div>

      <div v-if="data.ride && data.ride.captain" class="w-full float-left">
        <div class="w-full float-left flex flex-row items-center gap-2">
          <img src="../assets/profile/driver-avatar.svg" alt="driver" width="24" height="24"
            class="rounded-full overflow-hidden img-shadow" />
          <label class="text-sm">{{ $t("general.driver") }}: {{ data.ride.captain.full_name }} #{{ data.taxi_number ||
            data.ride.captain.username }}
          </label>
        </div>
        <div>
          <p class="text-sm" v-if="data.ride.car.brand_model">
            <span class="font-light">{{ $t(`place-order.car`) }}: {{
              data.ride.car.brand_model.brand.name_en }} ,
              {{ data.ride.car.brand_model.name_en }}, {{ data.ride.car.color.name_en }}</span>

          </p>
          <p class="text-sm" v-if="(data.ride.car.plate_number)">
            <span class="font-light">{{ $t(`place-order.plate-number`) }}: {{
              data.ride.car.plate_number }}</span>
          </p>
        </div>

      </div>
      <div class="w-full float-left">
        <div class="w-full flex flex-row items-center">
          <div class="rounded-full float-left" style="
              width: 15px;
              height: 15px;
              min-width: 15px;
              min-height: 15px;
              background-color: white;
              box-shadow: inset 0 0 0 2px #e10015;
            "></div>
          <label class="float-left ml-2 text-sm text-black">{{
            data.pick_up_area.name_en || data.pick_up_area.name_ar
          }}</label>
        </div>
        <div class="w-full flex flex-row items-center mt-4" v-if="data.pull_down_area">
          <div class="rounded-full float-left" style="
              width: 15px;
              height: 15px;
              min-width: 15px;
              min-height: 15px;
              background-color: #e10015;
            "></div>
          <label class="float-left ml-2 text-sm text-black">{{
            data.pull_down_area.name_en || data.pull_down_area.name_ar
          }}</label>
        </div>
      </div>
      <p class="w-full float-left text-sm text-gray">

      <p class="datetime">
        <span class="material-icons middle">schedule</span>
        <span class="middle">{{ formateDateTime(data.created_at) }}</span>
      </p>


      <p class="datetime" v-if="!data.now">
        <span class="material-icons middle">departure_board</span>
        <span class="middle">{{ formateDateTime(data.datetime) }}</span>
      </p>

      </p>
      <div v-if="actions" class="w-full float-left">
        <div class="divider"></div>
        <div class="w-full float-left mt-4 flex flex-row gap-2">
          <button v-for="(action, index) in actions" :key="index">
            <img :src="require(`../assets/${action.img}`)" @click="handleFunctionCall(action.method)" />
          </button>
        </div>
      </div>
    </div>


    <Dialog :header='$t("general.cancellation_reason")' v-model:visible="cancellationDialog"
      style="width: 500px; border-radius: 5px">
      <div v-for="option in cancellationReasons" :key="option.id" class="radio-option">
        <input type="radio" :value="option.id" v-model="returnCancellationReason" :id="option.id" class="radio-input" />
        <label :for="option.id" class="radio-label">{{ option['text' + primaryLang] }}</label>
      </div>
      <br />
      <button class="cancel-btn" :loading="loading" @click="submitCancelOrder">{{ $t("general.submit") }}</button>
    </Dialog>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Dialog from "primevue/dialog";

export default {
  name: "ReservationOrders",
  props: {
    initData: {
      type: Object,
      required: false,
    },
    id: {
      required: false,
    },
  },
  components: {
    Dialog
  },
  data() {
    return {
      cancellationReasons: [],
      cancellationDialog: false,
      returnCancellationReason: "",
      constraints: [],
      data: {},
      actions: [
        { img: "actions/cancel.svg", action: "cancel", method: "cancelOrder" },
      ],
      pickup: "",
      destination: "",
      dispatched: true,
      loading: false,
      showPastTime: false,
      timer: "",
    };
  },
  computed: {
    primaryLang() {
      if (this.$store.getters.selectedLanguage == "en")
        return "_en";
      else
        return "_ar";
    },

  },
  created() {
    if (this.initData) {
      this.data = this.initData;

      this.updateTimer();
      setInterval(() => {
        this.updateTimer();
      }, 1000);

      if (this.data.dynamic_constraints) {
        console.log("this.data.dynamicConstraints");
        console.log(this.data.dynamic_constraints);
        this.data.dynamic_constraints.forEach((item) => {
          this.constraints.push({
            title: item.Abbreviation,
            img: this.staticImageConstraint(item.Abbreviation),
            strike_through: item.strike_through || null
          });
        });
      }
      if (this.data.seats) {
        this.constraints.push({
          title: `${this.data.seats} Passenger${this.data.seats > 1 ? "s" : ""
            }`,
          img: "constraints/person.svg",
        });
      }
      // if (this.data.pets) {
      //   this.constraints.push({ title: "Pets", img: "constraints/animal.svg" });
      // }
      // if (this.data.wheelchair) {
      //   this.constraints.push({
      //     title: "Wheelchair",
      //     img: "constraints/wheelchair.svg",
      //   });
      // }
      // if (this.data.amex) {
      //   this.constraints.push({
      //     title: "Amex",
      //     img: "constraints/amex.svg",
      //   });
      // }
      // if (this.data.encompt) {
      //   this.constraints.push({
      //     title: "Encompt",
      //     img: "constraints/en_compt.svg",
      //   });
      // }
      // if (this.data.mad) {
      //   this.constraints.push({
      //     title: "mad",
      //     img: "constraints/mad.svg",
      //   });
      // }
      // if (this.data.test) {
      //   this.constraints.push({
      //     title: "test",
      //     img: "constraints/test.svg",
      //   });
      // }
    }
  },
  methods: {
    staticImageConstraint(constraint_name) {
      var imgPath = null;
      switch (constraint_name) {
        case "pets":
          imgPath = "constraints/animal.svg";
          break;
        case "test":
          imgPath = "constraints/test.svg";
          break;
        case "mad":
          imgPath = "constraints/mad.svg";
          break;
        case "amex":
          imgPath = "constraints/amex.svg";
          break;
        case "low_car":
          imgPath = "constraints/low_car.svg";
          break;
        case "wheelchair":
          imgPath = "constraints/wheelchair.svg";
          break;
        default:
          imgPath = null;
      }
      return imgPath;
    },
    openMap() {
      this.$router.push({
        name: "Details",
        params: {
          data: JSON.stringify(this.data),
          id: this.data.id,
        },
      });
    },
    updateTimer() {
      this.timer = moment(this.data.datetime).diff(moment(), "minutes");
    },
    cancelOrder() {
      this.$store
        .dispatch("getCancellationReasons")
        .then((data) => {
          this.cancellationReasons = data;
          this.cancellationDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });

    },
    submitCancelOrder() {
      if (!this.returnCancellationReason) {

        this.$notify({
          title: "Error",
          text: "Please choose a reason",
          type: "error",
        });
        return;
      }
      this.loading = true;
      this.axios
        .delete(`${this.$store.state.rootAPI}booking/${this.data.id}`, {
          params: {
            cancellation_reason_id: this.returnCancellationReason,
          },
        })
        .then(() => {
          this.$notify({
            title: "Deleted Successfully",
            text: `Order #${this.cancelledId} has been cancelled`,
            type: "Success",
          });
          this.cancelledId = null;
          this.cancellationDialog = false;
          this.getData();
        })
        .catch((err) => {
          this.$notify({
            title: "Error",
            text: err.response.data.message,
            type: "error",
          });

        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleFunctionCall(func) {
      this[func]();
    },
    formateDateTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },

  },
};
</script>

<style lang="scss" scoped>
.strike_through {
  text-decoration-line: line-through
}

button {
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: transparent;

  img {
    width: 100%;
    height: 100%;
  }
}

.constraint-icon {
  max-height: 16px;
  width: auto;
}

.img-shadow {
  box-shadow: 0 0 6px rgba(56, 69, 222, 0.12);
}

.radio-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.radio-option {
  padding-left: 30px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-family: 'Poppins';
}

.radio-input {
  width: 10%;
  cursor: pointer;
  accent-color: #4caf50;
  /* Change color of the radio button in modern browsers */
}

.radio-label {
  font-size: 16px;
  cursor: pointer;
}

.cancel-btn {
  width: 100%;
  border: 1px solid;
  border-radius: 5px;
  background: red;
  color: white;
  font-size: large;
  padding-top: 10px;
  padding-bottom: 10px;
  height: auto;
}

.datetime {
  width: 100%;
  float: left;
  font-size: 14px;
  color: #788e98;
  font-weight: 400;
}

.middle {
  vertical-align: middle;
  margin:2px;
}
</style>
